import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { concat } from 'rxjs/observable/concat';

import { forkEpic } from '../../utils/epics/forkEpic';
import getAreasEpic from '../areas/getAreas';
import getUsersEpic from '../users/getUser';
import getSiteUserEpic from '../sites/getSiteUser';
import {
  types as actions,
  setSitesAction,
  getAreasAction,
  setCurrentSiteAction,
  getSiteUserAction,
  getUserAction
} from '../../reducers/actions';
import { SiteService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_SITES),
    switchMap(action =>
      SiteService.getAll(store).pipe(
        switchMap(data => {          
          let { loadChildren, loadAreaChildren } = action;
          let currentSiteId = localStorage.getItem(`airfinder_selected_site`);
          let currentSite = data.find(site => site.id === currentSiteId) || data[0];        
          return loadChildren && data.length
            ? concat(
                of(setCurrentSiteAction(currentSite, true)),
                of(setSitesAction(data, loadChildren)),
                forkEpic(
                  getAreasEpic,
                  store,
                  getAreasAction(currentSite.id, loadAreaChildren),
                ),
                forkEpic(getUsersEpic, store, getUserAction(currentSite.id)),
                forkEpic(getSiteUserEpic, store, getSiteUserAction(currentSite.id))
              )
            : of(setSitesAction(data))
        }),
        catchError(retryAuthentication(action$, 'epics/sites/getSites'))
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/sites/getSites.js